import React, { useEffect, useState } from 'react';
import { AppBenefitsBanner } from '@wix/app-market-components';
import { appBenefitsBannerImpressionOrClickSrc96Evid211 } from '@wix/bi-logger-app-market-data/v2';
import { useBiLogger } from '../../hooks/use-bi-logger';
export const AppBenefits = ({ experiments, bundleApps, benefitApps, navigateToAppBenefitsPage, msid }) => {
    const biLogger = useBiLogger();
    const isBundlesToBenefitsExperiment = experiments.enabled('specs.app-market.MoveBundlesToBenefits');
    const [isCloseByClick, setIsCloseByClick] = useState(false);
    const hasExclusiveOfferApps = !!bundleApps?.length || !!benefitApps?.length;
    const isVisible = isBundlesToBenefitsExperiment && hasExclusiveOfferApps && !isCloseByClick;
    function bannerBIHandler(actionType) {
        biLogger.report(appBenefitsBannerImpressionOrClickSrc96Evid211({
            msid,
            tag_type: 'manage-apps',
            action_type: actionType,
        }));
    }
    function onCloseHandler() {
        bannerBIHandler('close');
        setIsCloseByClick(true);
    }
    function onMainActionClickHandler() {
        bannerBIHandler('cta');
        navigateToAppBenefitsPage();
    }
    useEffect(() => {
        if (isVisible) {
            bannerBIHandler('impression');
        }
    }, []);
    if (!isVisible) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("div", null,
        React.createElement(AppBenefitsBanner, { onClose: onCloseHandler, onMainActionClick: onMainActionClickHandler }));
};
//# sourceMappingURL=AppBenefits.js.map